import { defineMessages } from 'react-intl';

const _default_1: {
	verifiedAgentTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	verifiedIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	verifiedAgentTooltip: {
		id: 'agent-studio-ui-components.agent-verified.tooltip',
		defaultMessage: 'This agent has been verified by your organization.',
		description: 'Verified icon tooltip shown when hovering over the verified icon',
	},
	verifiedIconLabel: {
		id: 'agent-studio-ui-components.agent-verified.label',
		defaultMessage: 'Agent verified',
		description: 'Verified icon label for the agent studio side navigation',
	},
});
export default _default_1;
